var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoloteaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43.2 43.2",
    style: {
      enableBackground: "new 0 0 43.2 43.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#FFFFFF;}\n\t.st1{fill:#E10E49;}\n ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.2,21.6L21.6,43.1L0,21.6L21.6,0L43.2,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.2,21.6L36,14.4l-1.6-1.6V16l-1.6,1.6v-6.4l-1.6-1.6v9.6l-1.6,1.6V8l-0.8-0.8L21.6,0l-7.2,7.2L13.6,8v12.8 L12,19.2V9.6l-1.6,1.6v6.4L8.8,16v-3.2l-1.6,1.6L0,21.6l7.2,7.2l1.6,1.6v-3.2l1.6-1.6V32l1.6,1.6V24l1.6-1.6v12.8l0.8,0.8l7.2,7.2 l7.2-7.2l0.8-0.8V22.3l1.6,1.6v9.6l1.6-1.6v-6.4l1.6,1.6v3.2l1.6-1.6L43.2,21.6L43.2,21.6z M28,22.3v12.8l-1.6-1.6v-9.6l-1.6,1.6 v6.4l-1.6-1.6v-3.2l-1.6,1.6L20,27.1v3.2l-1.6,1.6v-6.4l-1.6-1.6v9.6l-1.6,1.6V22.3l-0.8-0.8l0.8-0.8V8l1.6,1.6v9.6l1.6-1.6v-6.4 l1.6,1.6V16l1.6-1.6l1.6,1.6v-3.2l1.6-1.6v6.4l1.6,1.6V9.6L28,8v12.8l0.8,0.8L28,22.3L28,22.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoloteaLogo);
export default __webpack_public_path__ + "static/media/VoloteaLogo.e88db1349ab0b13dfb083e38f0a31625.svg";
export { ForwardRef as ReactComponent };